<template>
  <!-- 学生标签项管理弹窗：沿用主页已解析校区，不再二次选择。最后更新：2026-10-29 -->
  <el-dialog
    :visible.sync="dialogVisible"
    width="960px"
    custom-class="dismissal-tag-category-manage-dialog"
    :close-on-click-modal="false"
    append-to-body
    @closed="onClosed"
  >
    <div slot="title" class="dialog-title-wrap">
      <span class="dialog-title-main">标签配置</span>
      <el-tag v-if="campusName" size="small" type="primary" effect="plain" class="dialog-campus-tag">
        {{ campusName }}
      </el-tag>
    </div>

    <div class="manage-body">
      <div class="custom-toolbar">
        <el-input
          v-model="keyword"
          size="small"
          clearable
          placeholder="搜索编码 / 标签项 / 内容"
          prefix-icon="el-icon-search"
          class="toolbar-search"
        />
        <el-button type="primary" size="small" @click="handleAdd">新增标签项</el-button>
      </div>

      <div class="tbl-scroll-host">
        <el-table
          :data="filteredList"
          v-loading="listLoading"
          class="tag-config-table"
          style="width: 100%"
          stripe
          height="420"
        >
          <el-table-column prop="categoryCode" label="编码" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="category-code">{{ scope.row.categoryCode || "—" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="categoryName" label="标签项" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="category-name">{{ scope.row.categoryName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="内容" min-width="220">
            <template slot-scope="scope">
              <div v-if="scope.row.valueList && scope.row.valueList.length" class="value-pill-group">
                <span
                  v-for="(v, idx) in scope.row.valueList"
                  :key="scope.row.categoryName + '-' + idx"
                  class="value-pill"
                >{{ v }}</span>
              </div>
              <span v-else class="cell-empty">未配置</span>
            </template>
          </el-table-column>
          <el-table-column label="应用于放学" width="108" align="center">
            <template slot-scope="scope">
              <span :class="['bool-badge', scope.row.applyToDismissal ? 'bool-badge--yes' : 'bool-badge--no']">
                {{ scope.row.applyToDismissal ? "是" : "否" }}
              </span>
              <span v-if="!scope.row.applyToDismissal" class="bool-sub">仅档案</span>
            </template>
          </el-table-column>
          <el-table-column prop="sortOrder" label="排序" width="64" align="center" />
          <el-table-column label="启用" width="72" align="center">
            <template slot-scope="scope">
              <span :class="['bool-badge', scope.row.isEnabled ? 'bool-badge--yes' : 'bool-badge--no']">
                {{ scope.row.isEnabled ? "是" : "否" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="handleDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-if="resolvedCampusId" class="pagination-container">
        <span class="list-total-hint">共 {{ filteredList.length }} 条{{ keywordTrimmed ? "（已筛选）" : "" }}</span>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </div>

    <el-dialog
      :title="editDialogTitle"
      :visible.sync="editDialogVisible"
      width="560px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="categoryForm" :model="categoryForm" :rules="categoryRules" label-width="120px">
        <el-form-item label="标签项" prop="categoryName">
          <el-input v-model="categoryForm.categoryName" placeholder="如：下午托管、中午用餐" />
        </el-form-item>
        <el-form-item v-if="categoryForm.categoryCode" label="编码">
          <el-input v-model="categoryForm.categoryCode" disabled />
          <div class="hint">创建时自动生成，修改标签项名称不会改变编码</div>
        </el-form-item>
        <el-form-item v-else-if="dialogStatus === 'create'" label="编码">
          <span class="code-pending">保存后自动生成</span>
        </el-form-item>
        <el-form-item label="内容" prop="valueTags">
          <div class="value-tag-editor" @click="focusValueInput">
            <span
              v-for="(v, idx) in valueTags"
              :key="v + '-' + idx"
              class="value-pill value-pill--editable"
            >
              {{ v }}
              <i class="el-icon-close value-pill-close" @click.stop="removeValueTag(idx)" />
            </span>
            <el-input
              ref="valueTagInput"
              v-model="valueInput"
              size="small"
              class="value-tag-input"
              placeholder="输入后按回车添加"
              @keyup.enter.native="addValueTag"
              @keydown.delete.native="onValueInputBackspace"
            />
          </div>
          <div class="hint">输入选项后按回车生成标签</div>
        </el-form-item>
        <el-form-item label="排序" prop="sortOrder">
          <el-input-number v-model="categoryForm.sortOrder" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item label="应用于放学">
          <el-switch v-model="categoryForm.applyToDismissal" />
          <div class="hint">关闭后仅作学生档案，H5 放学页不按该项分列</div>
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="categoryForm.isEnabled" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveCategory">确定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getDismissalTagCategories, saveDismissalTagCategory, deleteDismissalTagCategory } from "@/api/dismissal";
import { toDeptId } from "../../../utils/deptCascaderProps";

function parseValuesFromText(text) {
  if (!text || !String(text).trim()) return [];
  return String(text)
    .split(/[\r\n、,，;；/|]+/)
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
}

function mapCategory(raw) {
  const values = raw.Values || raw.values || [];
  const valuesText = raw.ValuesText != null ? raw.ValuesText : raw.valuesText;
  const fromValues = values.map((t) => (t.TagName != null ? t.TagName : t.tagName)).filter(Boolean);
  const valueList = fromValues.length > 0 ? fromValues : parseValuesFromText(valuesText);
  return {
    categoryCode: raw.CategoryCode != null ? raw.CategoryCode : raw.categoryCode,
    categoryName: raw.CategoryName != null ? raw.CategoryName : raw.categoryName,
    valuesText: valueList.join("、"),
    valueList,
    sortOrder: raw.SortOrder != null ? raw.SortOrder : raw.sortOrder,
    applyToDismissal: raw.ApplyToDismissal != null ? raw.ApplyToDismissal : raw.applyToDismissal,
    isEnabled: raw.IsEnabled != null ? raw.IsEnabled : raw.isEnabled,
    values
  };
}

export default {
  name: "DismissalTagCategoryManageDialog",
  props: {
    visible: { type: Boolean, default: false },
    /** 主页已解析的校区 Id */
    campusId: { type: [Number, String], default: 0 },
    /** 主页已解析的校区名称，用于标题展示 */
    campusName: { type: String, default: "" }
  },
  data() {
    return {
      list: [],
      listLoading: false,
      keyword: "",
      editDialogVisible: false,
      dialogStatus: "create",
      saving: false,
      valueTags: [],
      valueInput: "",
      changed: false,
      categoryForm: {
        originalCategoryName: "",
        categoryCode: "",
        categoryName: "",
        valueTags: [],
        sortOrder: 0,
        applyToDismissal: true,
        isEnabled: true
      },
      categoryRules: {
        categoryName: [{ required: true, message: "请输入标签项名称", trigger: "blur" }],
        valueTags: [
          {
            validator: (rule, value, callback) => {
              if (!this.valueTags || this.valueTags.length === 0) {
                callback(new Error("请至少添加一个选项（输入后按回车）"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ]
      },
      maxCategoryCount: 8
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    resolvedCampusId() {
      return toDeptId(this.campusId);
    },
    keywordTrimmed() {
      return String(this.keyword || "").trim().toLowerCase();
    },
    /** 按关键词筛选编码 / 标签项 / 内容。最后更新：2026-10-29 */
    filteredList() {
      const kw = this.keywordTrimmed;
      if (!kw) return this.list;
      return (this.list || []).filter((row) => {
        const code = String(row.categoryCode || "").toLowerCase();
        const name = String(row.categoryName || "").toLowerCase();
        const values = String(row.valuesText || (row.valueList || []).join("、")).toLowerCase();
        return code.includes(kw) || name.includes(kw) || values.includes(kw);
      });
    },
    editDialogTitle() {
      return this.dialogStatus === "create" ? "新增标签项" : "编辑标签项";
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.changed = false;
        this.initOnOpen();
      }
    }
  },
  methods: {
    /** 弹窗打开时直接按主页校区加载列表。最后更新：2026-10-29 */
    initOnOpen() {
      this.resetList();
      if (!this.resolvedCampusId) {
        this.$message.warning("当前未解析到校区，无法配置标签");
        return;
      }
      this.getList();
    },

    onClosed() {
      if (this.changed) {
        this.$emit("changed");
      }
      this.editDialogVisible = false;
      this.resetList();
    },

    resetList() {
      this.list = [];
      this.listLoading = false;
      this.keyword = "";
    },

    ensureCampus() {
      if (!this.resolvedCampusId) {
        this.$message.warning("当前未解析到校区");
        return false;
      }
      return true;
    },

    getList() {
      if (!this.resolvedCampusId) return;
      this.listLoading = true;
      // 校区最多 8 项，一次拉全量后前端搜索即可
      getDismissalTagCategories({
        campusId: this.resolvedCampusId,
        page: 1,
        intPageSize: 50
      })
        .then((res) => {
          if (res.data.success && res.data.response) {
            const pm = res.data.response;
            const rows = pm.data || pm.Data || [];
            this.list = rows.map(mapCategory);
          } else {
            this.list = [];
            this.$message.warning(res.data.msg || "加载失败");
          }
        })
        .catch(() => {
          this.list = [];
          this.$message.error("加载失败");
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    handleAdd() {
      if (!this.ensureCampus()) return;
      if (this.list.length >= this.maxCategoryCount) {
        this.$message.warning(`每个校区最多 ${this.maxCategoryCount} 个标签项`);
        return;
      }
      this.resetValueTagsEditor([]);
      this.categoryForm = {
        originalCategoryName: "",
        categoryCode: "",
        categoryName: "",
        sortOrder: this.list.length,
        applyToDismissal: true,
        isEnabled: true
      };
      this.dialogStatus = "create";
      this.editDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.categoryForm) this.$refs.categoryForm.clearValidate();
      });
    },

    handleEdit(row) {
      this.resetValueTagsEditor(row.valueList || parseValuesFromText(row.valuesText));
      this.categoryForm = {
        originalCategoryName: row.categoryName,
        categoryCode: row.categoryCode || "",
        categoryName: row.categoryName,
        sortOrder: row.sortOrder,
        applyToDismissal: row.applyToDismissal,
        isEnabled: row.isEnabled
      };
      this.dialogStatus = "update";
      this.editDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.categoryForm) this.$refs.categoryForm.clearValidate();
      });
    },

    handleDel(row) {
      if (!this.ensureCampus()) return;
      this.$confirm(`确认删除标签项「${row.categoryName}」及其全部选项？`, "提示", { type: "warning" })
        .then(() => deleteDismissalTagCategory({ campusId: this.resolvedCampusId, categoryName: row.categoryName }))
        .then((res) => {
          if (res.data.success) {
            this.$message.success("删除成功");
            this.changed = true;
            this.getList();
          } else {
            this.$message.error(res.data.msg || "删除失败");
          }
        })
        .catch(() => {});
    },

    resetValueTagsEditor(list) {
      this.valueTags = Array.isArray(list) ? [...list] : [];
      this.categoryForm.valueTags = this.valueTags;
      this.valueInput = "";
    },

    syncValueTagsToForm() {
      this.categoryForm.valueTags = [...this.valueTags];
    },

    focusValueInput() {
      this.$nextTick(() => {
        const input = this.$refs.valueTagInput;
        if (input && input.focus) input.focus();
      });
    },

    addValueTag() {
      const name = (this.valueInput || "").trim();
      if (!name) return;
      if (this.valueTags.some((v) => String(v).toLowerCase() === name.toLowerCase())) {
        this.$message.warning("选项已存在");
        this.valueInput = "";
        return;
      }
      this.valueTags.push(name);
      this.syncValueTagsToForm();
      this.valueInput = "";
      if (this.$refs.categoryForm) this.$refs.categoryForm.validateField("valueTags");
      this.focusValueInput();
    },

    removeValueTag(index) {
      this.valueTags.splice(index, 1);
      this.syncValueTagsToForm();
      if (this.$refs.categoryForm) this.$refs.categoryForm.validateField("valueTags");
    },

    onValueInputBackspace() {
      if (this.valueInput === "" && this.valueTags.length > 0) {
        this.valueTags.pop();
        this.syncValueTagsToForm();
        if (this.$refs.categoryForm) this.$refs.categoryForm.validateField("valueTags");
      }
    },

    buildValuesText() {
      return (this.valueTags || []).join("、");
    },

    saveCategory() {
      if (this.valueInput && this.valueInput.trim()) {
        this.addValueTag();
      }
      this.syncValueTagsToForm();
      this.$refs.categoryForm.validate((valid) => {
        if (!valid) return;
        if (!this.ensureCampus()) return;
        this.saving = true;
        saveDismissalTagCategory({
          CampusId: this.resolvedCampusId,
          OriginalCategoryName: this.categoryForm.originalCategoryName || this.categoryForm.categoryName,
          CategoryName: this.categoryForm.categoryName,
          ValuesText: this.buildValuesText(),
          SortOrder: this.categoryForm.sortOrder,
          ApplyToDismissal: this.categoryForm.applyToDismissal,
          IsEnabled: this.categoryForm.isEnabled
        })
          .then((res) => {
            if (res.data.success) {
              this.$message.success("保存成功");
              this.editDialogVisible = false;
              this.changed = true;
              this.getList();
            } else {
              this.$message.error(res.data.msg || "保存失败");
            }
          })
          .catch(() => this.$message.error("保存失败"))
          .finally(() => {
            this.saving = false;
          });
      });
    }
  }
};
</script>

<style scoped>
.manage-body {
  min-height: 480px;
}
.dialog-title-wrap {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.dialog-title-main {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.dialog-campus-tag {
  font-weight: 500;
}
.custom-toolbar {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.toolbar-search {
  width: 260px;
  max-width: 100%;
}
.list-total-hint {
  font-size: 13px;
  color: #909399;
}
.hint {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 4px;
}
.value-tag-editor {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 6px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  cursor: text;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.value-tag-editor:focus-within {
  border-color: var(--btn-primary, #2563eb);
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
}
.value-tag-input {
  flex: 1;
  min-width: 140px;
}
.value-tag-input >>> .el-input__inner {
  border: none;
  padding-left: 0;
  height: 28px;
  line-height: 28px;
}
.tag-config-table >>> .el-table__body td {
  padding: 14px 0;
}
.category-code {
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  color: #606266;
}
.category-name {
  font-weight: 600;
  color: #303133;
}
.code-pending {
  color: #909399;
  font-size: 13px;
}
.value-pill-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.value-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  font-size: 13px;
  line-height: 1;
  color: #1d5fbf;
  background: #ecf5ff;
  border: 1px solid #c6e2ff;
  border-radius: 16px;
  white-space: nowrap;
  transition: all 0.2s ease;
}
.value-pill:hover {
  background: #dbecff;
  border-color: #a3cfff;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.value-pill--editable {
  padding-right: 8px;
}
.value-pill-close {
  margin-left: 6px;
  font-size: 12px;
  color: #909399;
  cursor: pointer;
  border-radius: 50%;
  padding: 2px;
  transition: all 0.2s ease;
}
.value-pill-close:hover {
  color: #f56c6c;
  background: rgba(245, 108, 108, 0.12);
}
.bool-badge {
  display: inline-block;
  min-width: 28px;
  padding: 2px 8px;
  font-size: 12px;
  line-height: 18px;
  border-radius: 4px;
  font-weight: 500;
}
.bool-badge--yes {
  color: #52c41a;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
}
.bool-badge--no {
  color: #ff4d4f;
  background: #fff2f0;
  border: 1px solid #ffccc7;
}
.bool-sub {
  display: block;
  margin-top: 2px;
  font-size: 11px;
  color: #c0c4cc;
  line-height: 1.2;
}
.cell-empty {
  color: #c0c4cc;
  font-size: 12px;
}
.pagination-container {
  margin-top: 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
